import React, { useEffect, useState, useContext, useRef } from 'react'
import { NavLink, useNavigate, useLocation } from 'react-router-dom';
import { Collapse, Navbar, NavbarToggler, NavbarBrand, Nav, NavItem, UncontrolledDropdown, DropdownToggle, DropdownMenu, DropdownItem, Container } from 'reactstrap';
//constant
import { directUrl, homePageUrl } from '../../../helpers/Constants';
//assets
import logo from "../../../assets/image/Logo3.svg";
import { userStore } from '../../../stores';
import './Style.css'
import { MyLocation } from '@mui/icons-material';
import { requestApi } from "../../../request-api";
import { GlobalContext } from '../../../contexts/GlobalContext';
import NotificationBadge from 'react-notification-badge';
import { Effect } from 'react-notification-badge';
import { API_URL } from '../../../config';
import { io } from 'socket.io-client'
function Header(props) {
	const { notification, setNotification, roomId, setRoomId } = useContext(GlobalContext)
	const location = useLocation();
	let myLocation = location.pathname;
	let navigate = useNavigate()
	let { hideHeader } = props;
	const [user, setUser] = useState({});
	// const [notifications, setNotification] = useState();
	// const ENDPOIN T = API_URL
	// const socket = useRef()
	let [isOpen, setIsOpen] = useState(false)
	//Mobile menu  
	const toggle = () => {
		setIsOpen(!isOpen)
	}
	const logout = () => {
		// socket = io(ENDPOINT)
		// socket.disconnect()
		localStorage.clear()
		navigate(`${directUrl}sign-in`)
	}
	const directToSetting = () => {
		navigate(`${directUrl}auditor/create-user-profile/settings`)
	}
	useEffect(() => {
		userData()
		getNotification()
	}, []);
	const userData = () => {
		requestApi(`/superadmin/userData`, {
			method: "get",
		})
			.then((data) => {
				if (data.statusCode === 200) {
					setUser(data.data)
					// console.log("local storage::", user.name)
				} else {
				}
			})
			.catch((error) => {
				console.log("Error", error);
			});
	};
	const seenStatusActivityLog = (e, activity_id) => {
		e.preventDefault()
		requestApi(`/activity/changeSeenStatus/${activity_id}`, {
			method: "get",
		})
			.then((data) => {
			})
			.catch((error) => {
				console.log("Error", error);
			})
	}
	const getNotification = () => {
		requestApi(`/activity/notification`, {
			method: "get",
		})
			.then((data) => {
				if (data.statusCode === 200) {
					setNotification(data.data)
					// console.log("local storage111::", data.data)
				} else {
				}
			})
			.catch((error) => {
				console.log("Error", error);
			});
	};
	return (
		<>
			{!hideHeader && <header className='bs-header bs-head ' >
				<Navbar expand="xl">
					<div className='navbar-outer'>
						<NavbarBrand href={`/auditor/dashboard`}>
							<img className='nav-logo' src={logo} alt='GLYPHER TECH LOGO' />
						</NavbarBrand>
						<NavbarToggler onClick={toggle} />
						<Collapse isOpen={isOpen} navbar>
							<Nav className="ml-auto " navbar>
								<NavItem>
									<NavLink className="nav-link first" exact to={`auditor/dashboard`}
										style={{
											textDecoration: 'none',
											color: myLocation.includes('auditor/dashboard') ? '#000' : '#555',
											fontWeight: myLocation.includes('auditor/dashboard') ? 'bold' : 'normal',
										}}>
										{/* <i className='icon icon-home'></i> */}
										Dashboard
									</NavLink>
								</NavItem>
								<NavItem>
									<NavLink className={myLocation.includes('auditor/action') ? 'nav-link active' : 'nav-link'} to={`auditor/action`}

										style={{
											textDecoration: 'none',
											color: myLocation.includes('auditor/action') ? '#000' : '#555',
											fontWeight: myLocation.includes('auditor/action') ? 'bold' : 'normal',
										}}>
										{/* <i className='icon icon-active-report'></i> */}

										Action
									</NavLink>
								</NavItem>
								<NavItem>
									<NavLink className={myLocation.includes('auditor/view/legislation-list') || myLocation.includes('auditor/legislation-list') || myLocation.includes('auditor/create-report') || myLocation.includes('auditor/upload-report') ? 'nav-link active' : 'nav-link'} exact to={`auditor/reports`}
										style={{
											textDecoration: 'none',
											color: myLocation.includes('auditor/reports') ? '#000' : '#555',
											fontWeight: myLocation.includes('auditor/reports') ? 'bold' : 'normal',
										}}>
										{/* <i className='icon icon-report'></i> */}
										REPORTS
									</NavLink>
								</NavItem>
								{/* <NavItem>
									<NavLink className={myLocation.includes('auditor/create-user-profile/complaincer-officer') || myLocation.includes('auditor/create-user-profile/approver') ? 'nav-link active' : 'nav-link'} to={`auditor/user-profile`}><i className='icon icon-user'></i>USER PROFILE</NavLink>
								</NavItem>
								<NavItem>
									<NavLink className={myLocation.includes('auditor/create-company') || myLocation.includes('auditor/clients-edit') || myLocation.includes('auditor/branch-detail') ? 'nav-link active' : 'nav-link'} to={`auditor/clients`}><i className='icon icon-client'></i>CLIENTS</NavLink>
								</NavItem> */}
								<NavItem>
									<NavLink className={myLocation.includes('auditor/comments') ? 'nav-link active' : 'nav-link'} to={`auditor/comments`}
										style={{
											textDecoration: 'none',
											color: myLocation.includes('auditor/comments') ? '#000' : '#555',
											fontWeight: myLocation.includes('auditor/comments') ? 'bold' : 'normal',
										}}>
										{/* <i className='icon icon-comment'></i> */}
										COMMENTS
									</NavLink>
								</NavItem>
								{/* <NavItem>
									<NavLink className={myLocation.includes('auditor/create-branch') || myLocation.includes('auditor/branch-edit') ? 'nav-link active' : 'nav-link'} to={`auditor/branch`}><i className='icon icon-branch'></i>BRANCH</NavLink>
								</NavItem> */}
								<NavItem>
									<NavLink className={myLocation.includes('auditor/activity-log') ? 'nav-link active' : 'nav-link'} to={`auditor/activity-log`}
										style={{
											textDecoration: 'none',
											color: myLocation.includes('auditor/activity-log') ? '#000' : '#555',
											fontWeight: myLocation.includes('auditor/activity-log') ? 'bold' : 'normal',
										}}
									>
										{/* <i className='icon icon-active-report'></i> */}
										ACTIVITY LOG
									</NavLink>
								</NavItem>
							</Nav>
							<Nav className="ml-auto navbar-right" navbar>
								{/* <UncontrolledDropdown className='user-drop' nav inNavbar>
									<DropdownToggle className='notification-box' to={`notification`} nav caret>
										<NotificationBadge
											count={notification.length}
											effect={Effect.SCALE}
										/>
										<i className='icon icon-bell'></i>
									</DropdownToggle>
									<DropdownMenu className='notification' right>
										{notification != null ? notification.length > 0 ? (notification.map((noti) => {
											if (noti.chat_id != null) {
												return (
													<DropdownItem onClick={() => { setRoomId(noti.chat_id); setNotification(notification.filter((n) => n !== noti)); navigate(`${directUrl}auditor/comments`) }}>You have message in {noti.chat_id}</DropdownItem>
												)
											}
											else if (noti.comments !== null) {
												return (
													<DropdownItem onClick={(e) => {
														seenStatusActivityLog(e, noti.id); setNotification(notification.filter((n) => n !== noti))
													}}>{noti.comments}</DropdownItem>
												)
											}
										})) : <DropdownItem>{"No Notifications"}</DropdownItem> : <DropdownItem>{"No Notifications"}</DropdownItem>}
									</DropdownMenu>
								</UncontrolledDropdown> */}
								{/* <UncontrolledDropdown className='user-drop' nav inNavbar>
									<DropdownToggle to={`notifications`} nav caret>
										<i className='icon icon-bell'></i>
									</DropdownToggle>
									<DropdownMenu className='notification' right>
										{}
										{notifications != null ? notifications.length >0?( notifications.map((noti)=>{
											if(noti.comments != null){
												return(
													<DropdownItem >{noti.comments}</DropdownItem>
												)
											}
											
										})):<DropdownItem>{"No Notifications"}</DropdownItem>:null}
									</DropdownMenu>
								</UncontrolledDropdown> */}
								<UncontrolledDropdown className='user-drop' nav inNavbar>
									<DropdownToggle nav caret className="d-flex align-items-center">
										<img
											src="https://media.istockphoto.com/id/1223671392/vector/default-profile-picture-avatar-photo-placeholder-vector-illustration.jpg?s=612x612&w=0&k=20&c=s0aTdmT5aU6b8ot7VKm11DeID6NctRCpB755rA1BIP0="
											alt="User"
											style={{
												width: '32px',
												height: '32px',
												borderRadius: '50%',
												marginRight: '8px',
												objectFit: 'cover',
											}}
										/>
										<div className="d-none d-md-block text-start">
											<div style={{ fontWeight: 'bold', fontSize: '14px' }}>{user.name}</div>
											<div style={{ fontSize: '12px', color: '#777' }}>{user.email}</div>
										</div>
									</DropdownToggle>
									<DropdownMenu right>
										<DropdownItem>Hi, {user.name}</DropdownItem>
										<DropdownItem onClick={directToSetting}>Edit Profile</DropdownItem>
										<DropdownItem onClick={logout} >Log Out</DropdownItem>
									</DropdownMenu>
								</UncontrolledDropdown>
							</Nav>
						</Collapse>
					</div>
				</Navbar>
			</header>}
		</>
	)
}
export default Header
